// removed by extract-text-webpack-plugin
module.exports = {"dialog":"MembershipCardModal--dialog--hARz0JyS","dialog-body":"MembershipCardModal--dialog-body--1YoqfQSo","dialogBody":"MembershipCardModal--dialog-body--1YoqfQSo","close-icon":"MembershipCardModal--close-icon--3XLKjC3q","closeIcon":"MembershipCardModal--close-icon--3XLKjC3q"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/MembershipCard/MembershipCardModal.css
// module id = 1276
// module chunks = 2